module.exports = __webpack_public_path__ + "img/qrcode-generator.e07e6162.svg";